import React from 'react';
import { useTranslation } from 'react-i18next';
import chunk from 'lodash/chunk';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import SearchIcon from '@wix/da-ds/pkg/Icons/24x24/Search';
import Emote from '../Emote';
import { useGridNavigationHotkeys, EMOTES_PER_ROW } from './hotkeys';
import s from './EmoteList.scss';
const EmoteList = ({ activeStream, onEmoteSelect })=>{
    const { t } = useTranslation();
    var _activeStream_results;
    const emotes = (_activeStream_results = activeStream === null || activeStream === void 0 ? void 0 : activeStream.results) !== null && _activeStream_results !== void 0 ? _activeStream_results : [];
    const { focusedIndex, lastFocusedIndex, onKeyDown, setFocusedIndex, clearFocusedIndex } = useGridNavigationHotkeys(emotes.length);
    if (emotes.length === 0) {
        return /*#__PURE__*/ React.createElement("div", {
            className: s['notfound']
        }, /*#__PURE__*/ React.createElement(SearchIcon, {
            size: IconSize.HUGE,
            className: s['notfound-icon'],
            disableDefaultColors: true
        }), t('emoteselector.notfound'));
    }
    const emoteRows = chunk(emotes, EMOTES_PER_ROW);
    return /*#__PURE__*/ React.createElement("div", {
        role: "grid"
    }, emoteRows.map((row, rowIndex)=>/*#__PURE__*/ React.createElement("div", {
            className: s['row'],
            role: "row",
            "aria-rowindex": rowIndex + 1,
            key: rowIndex
        }, row.map((emote, columnIndex)=>{
            const realIndex = columnIndex + rowIndex * EMOTES_PER_ROW;
            return /*#__PURE__*/ React.createElement(Emote, {
                key: `emote-${rowIndex}-${columnIndex}`,
                emote: emote,
                onClick: onEmoteSelect,
                onKeyDown: onKeyDown,
                onFocus: ()=>focusedIndex === null && lastFocusedIndex === realIndex && setFocusedIndex(realIndex),
                onBlur: ()=>focusedIndex === realIndex && clearFocusedIndex(),
                focused: realIndex === focusedIndex,
                tabIndex: focusedIndex === null && lastFocusedIndex === realIndex ? 0 : -1,
                "aria-colindex": columnIndex + 1,
                role: "gridcell"
            });
        }))));
};
EmoteList.displayName = 'EmoteList';
export default EmoteList;
